import React, { useState } from 'react';
import './HoursDisplay.css';

const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const DAY_LABELS = {
  monday: 'Monday', tuesday: 'Tuesday', wednesday: 'Wednesday', thursday: 'Thursday',
  friday: 'Friday', saturday: 'Saturday', sunday: 'Sunday',
};
// Date.getDay(): 0=Sunday..6=Saturday
const JS_DAY_TO_KEY = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

function formatTime(hhmm) {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const period = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  return m === 0 ? `${hour12}${period}` : `${hour12}:${String(m).padStart(2, '0')}${period}`;
}

function dayRangeText(day) {
  if (!day || day.closed || !day.open || !day.close) return 'Closed';
  return `${formatTime(day.open)} – ${formatTime(day.close)}`;
}

// Handles overnight ranges (e.g. open 17:00, close 02:00 the next day).
function isOpenNow(day, now) {
  if (!day || day.closed || !day.open || !day.close) return false;
  const minutesNow = now.getHours() * 60 + now.getMinutes();
  const [oh, om] = day.open.split(':').map(Number);
  const [ch, cm] = day.close.split(':').map(Number);
  const openMinutes = oh * 60 + om;
  const closeMinutes = ch * 60 + cm;
  if (closeMinutes > openMinutes) {
    return minutesNow >= openMinutes && minutesNow < closeMinutes;
  }
  // Overnight — closes after midnight.
  return minutesNow >= openMinutes || minutesNow < closeMinutes;
}

export default function HoursDisplay({ hours }) {
  const [expanded, setExpanded] = useState(false);
  if (!hours || typeof hours !== 'object') return null;

  const now = new Date();
  const todayKey = JS_DAY_TO_KEY[now.getDay()];
  const today = hours[todayKey];
  const openNow = isOpenNow(today, now);

  return (
    <div className={`hours-display ${expanded ? 'hours-display--expanded' : ''}`}>
      <button
        type="button"
        className="hours-display__header"
        onClick={() => setExpanded(e => !e)}
        aria-expanded={expanded}
      >
        <span className={`hours-display__indicator ${openNow ? 'hours-display__indicator--open' : 'hours-display__indicator--closed'}`}>
          {openNow ? 'Open now' : 'Closed now'}
        </span>
        <span className="hours-display__today">{dayRangeText(today)}</span>
        <span className="hours-display__chevron" aria-hidden="true">{expanded ? '▲' : '▼'}</span>
      </button>

      {expanded && (
        <table className="hours-display__table">
          <tbody>
            {DAYS.map(day => (
              <tr key={day} className={day === todayKey ? 'hours-display__row--today' : ''}>
                <td>{DAY_LABELS[day]}</td>
                <td>{dayRangeText(hours[day])}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
